//
//
//
//
//
//
//
//

export default {
  components: {
  },
  props:["dataConfig"],
  data() {
    return {

      fixed:false,
      
    };
  },
  created() {    
  },

  mounted(){
    if(!this.dataConfig){
      this.dataConfig = {};
    }

    // if(!this.dataConfig.Title){
    //   this.dataConfig.Title = "标题信息";
    // }
    
  },

  methods: {

    setTitle(title){
      this.dataConfig.Title = title;
    },

    onBackClick() {
      this.$msg.confirm("是否确定要返回?", () => {
        window.history.back(-1); 
      });
    },

  }
};
